import { useMutation } from "@tanstack/react-query";
import { gql } from "graphql-request";

import { client } from "@krea/customer-features/graphql";
import { CONTACT_CUSTOMER_SERVICE_STORE_KEY } from "@krea/customer-features/store/queryClient";

export interface LoanApplicationContactCustomerServiceInput {
  loanApplicationId: string;
  noSigningRightsCustomerExplanation: {
    message: string;
  };
}

export const CONTACT_CUSTOMER_SERVICE_MUTATION = gql`
  mutation contactCustomerService(
    $input: LoanApplicationContactCustomerServiceInput!
  ) {
    loanApplicationContactCustomerService(input: $input) {
      ok
    }
  }
`;

export const useContactCustomerService = () => {
  const mutation = useMutation({
    mutationKey: [CONTACT_CUSTOMER_SERVICE_STORE_KEY],
    mutationFn: async (input: LoanApplicationContactCustomerServiceInput) => {
      return await client.request(CONTACT_CUSTOMER_SERVICE_MUTATION, {
        input,
      });
    },
    onError: (err) => {
      console.error(
        "Failed to contact customer service with explanation for having no signing rights ",
        err,
      );
    },
  });

  return mutation;
};
